import { useContext } from 'react';

import { ArticleContext } from '../Article.context';

export const StyledButton = (props: StyledButtonProps) => {
	const {
		id,
		text_lang,
		text,
		align,
		style,
		size,
		width,
		link,
		font_size,
		resource,
		pageid,
		pagetarget,
	} = props;
	const { lang } = useContext(ArticleContext);
	let content: any = text;
	if (lang && text_lang?.[lang]) {
		content = text_lang[lang];
	}
	return (
		<Button
			id={id}
			align={align}
			width={width}
			resource={resource}
			pageId={pageid}
			pageTarget={pagetarget}
			size={size}
			link={link}
			fontSize={`${font_size}`}
			StyleID={style}
			text={content}
			textTransform={props.case}
		/>
	);
};

interface StyledButtonProps {
	id: string;
	text_lang: string;
	text: any;
	align: string;
	style: string;
	size: string;
	width: any;
	case: string;
	link: string;
	resource: string;
	pagetarget: string;
	pageid: string;
	externallinktarget: string;
	font_size: any;
}

export const Button = (props: ButtonProps) => {
	const {
		id = '',
		align = 'center',
		size = 'medium',
		link = '',
		text = '',
		StyleID = 'none',
		resource,
		pageId,
		pageTarget,
	} = props;
	const { onLightboxTargetClick, onEventSend } = useContext(ArticleContext);
	const containerStyle: any = {
		display: 'flex',
		width: '100%',
	};
	const componentStyle: any = {};

	let onClick = () => {};

	const attr: any = {};

	switch (resource) {
		case 'url':
			if (link) {
				onClick = () => {
					onEventSend({
						event: 'external',
						data: {
							url: link,
							componentId: id,
							componentType: 'button',
						},
					});
					window.open(link, '_blank');
				};
			}
			break;
		case 'page':
			if (pageId && pageTarget) {
				onClick = () => {
					onLightboxTargetClick({
						id: pageId,
						resource,
						target: pageTarget,
					});
				};
			}
			break;
		default:
			attr['disabled'] = true;
			break;
	}

	// Alignment
	switch (align) {
		case 'left':
			containerStyle.justifyContent = 'flex-start';
			break;
		case 'right':
			containerStyle.justifyContent = 'flex-end';
			break;
		default:
			containerStyle.justifyContent = 'center';
	}

	// Size
	switch (size) {
		case 'xsmall':
			componentStyle.padding = '2px 5px';
			break;
		case 'small':
			componentStyle.padding = `5px 10px`;
			break;
		case 'medium':
			componentStyle.padding = `8px 18px`;
			break;
		case 'large':
			componentStyle.padding = `12px 30px`;
			break;
		case 'xlarge':
			componentStyle.padding = `14px 40px`;
			break;
	}

	return (
		<div id={id} style={containerStyle}>
			<button
				{...attr}
				className={StyleID}
				style={componentStyle}
				onClick={onClick}
			>
				{text}
			</button>
		</div>
	);
};

interface ButtonProps {
	id: string;
	width: any;
	align: string;
	size: string;
	text: any;
	link: string;
	StyleID: string;
	fontSize: any;
	textTransform: string;
	resource: string;
	pageId: string;
	pageTarget: string;
}

// TODO Implement this
export const SocialButton = (props: SocialButtonProps) => {
	const { text, url } = props;
	const uri = [];
	if (text) {
		uri.push(text);
	}
	uri.push(url ? url : window.location.href);

	const handleShare = () => {
		switch (props.type) {
			case 'twitter':
			case 'x':
				let twitterUri = [`url=${url ? url : window.location.href}`];

				if (text) {
					twitterUri.push(`text=${text}`);
				}
				const twitterUrl = `https://twitter.com/intent/tweet?${twitterUri.join('&')}`;
				window.open(twitterUrl, '_blank', 'width=800,height=600');
				return;
			case 'fb':
				const facebookUri = [];
				if (text) {
					facebookUri.push(text);
				}
				facebookUri.push(url ? url : window.location.href);
				const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${facebookUri}`;
				window.open(facebookUrl, '_blank', 'width=800,height=600');
				return;
		}
	};

	switch (props.type) {
		case 'fb':
			return (
				<button style={{ cursor: 'pointer' }} onClick={handleShare}>
					<FacebookIcon />
				</button>
			);
		case 'x':
		case 'twitter':
			return (
				<button style={{ cursor: 'pointer' }} onClick={handleShare}>
					<XIcon />
				</button>
			);
	}

	return null;
};

interface SocialButtonProps {
	type: 'fb' | 'twitter' | 'x';
	text: string;
	url: string;
}

function FacebookIcon() {
	return (
		<svg
			id="facebookShareButton"
			width="40px"
			height="40px"
			viewBox="126.445 2.281 589 589"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="420.945" cy="296.781" r="294.5" fill="#3c5a9a"></circle>
			<path
				d="M516.704 92.677h-65.239c-38.715 0-81.777 16.283-81.777 72.402
             .189 19.554 0 38.281 0 59.357H324.9v71.271h46.174v205.177h84.847
             V294.353h56.002l5.067-70.117h-62.531s.14-31.191 0-40.249c0-22.177
             23.076-20.907 24.464-20.907 10.981 0 32.332.032 37.813 0V92.677h-.032z"
				fill="#ffffff"
			></path>
		</svg>
	);
}

function XIcon() {
	return (
		<svg
			width="40px"
			height="40px"
			xmlns="http://www.w3.org/2000/svg"
			shape-rendering="geometricPrecision"
			text-rendering="geometricPrecision"
			imageRendering="optimizeQuality"
			fill-rule="evenodd"
			clip-rule="evenodd"
			viewBox="0 0 512 512"
		>
			<path d="M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0z"></path>

			<path
				fill="#fff"
				fill-rule="nonzero"
				d="M318.64 157.549h33.401l-72.973 83.407
             85.85 113.495h-67.222l-52.647-68.836-60.242
             68.836h-33.423l78.052-89.212-82.354-107.69h68.924
             l47.59 62.917 55.044-62.917zm-11.724 176.908h18.51
             L205.95 176.493h-19.86l120.826 157.964z"
			></path>
		</svg>
	);
}
